/** CoStar.Api.MarketAnalytics.SearchMarkets.PropertySearch.PropertySegment */
export var PropertySegment;
(function (PropertySegment) {
    PropertySegment[PropertySegment["Student"] = 1] = "Student";
    PropertySegment[PropertySegment["MultiFamily"] = 2] = "MultiFamily";
})(PropertySegment || (PropertySegment = {}));
/** CoStar.Api.MarketAnalytics.SearchMarkets.PropertySearch.PropertySearchType */
export var PropertySearchType;
(function (PropertySearchType) {
    PropertySearchType[PropertySearchType["AllProperties"] = 1] = "AllProperties";
    PropertySearchType[PropertySearchType["UnderConstruction"] = 2] = "UnderConstruction";
    PropertySearchType[PropertySearchType["ForSale"] = 3] = "ForSale";
    PropertySearchType[PropertySearchType["RecentlySold"] = 4] = "RecentlySold";
})(PropertySearchType || (PropertySearchType = {}));
